import { ReactNode } from "react";
import { isMobileOnly } from "react-device-detect";
import styled from "styled-components";
import { UserSubscriptionTier } from "@lifeat/shared/user/UserSubscriptionTier";
import { getUserSubscriptionTier } from "@lifeat/shared/user/UserUtil";
import ButtonDivider from "@common/LifeAtButton/ButtonDivider";
import { useAppearanceContext } from "@contexts/AppearanceContext";
import { useUserContext } from "@contexts/UserContext";
import Styles from "@themes/Styles";
import UserMetricsButton from "@user/components/UserMetrics/UserMetricsButton";
import CannyChangelog from "../../../features/virtual-space/components/Sidebar/CannyChangelog";
import FullScreenButton from "../OverlayButtons/AllOverlayButtons/DisplayToggleButtons/FullScreenButton";
import SupportChatButton from "../OverlayButtons/AllOverlayButtons/SupportChatButton";
import AppModeDropdown from "./TopNavigationComponents/AppModeDropdown";
import DesktopAppButton from "./TopNavigationComponents/DesktopAppButton";
import GroupTimerButton from "./TopNavigationComponents/GroupTimerButton";
import HideOnMobileScreenSizes from "./TopNavigationComponents/HideOnMobileScreenSizes";
import MainDropdownMenu from "./TopNavigationComponents/MainDropdownMenu";
import RoomsButtons from "./TopNavigationComponents/RoomsButtons";
import UpgradeButton from "./TopNavigationComponents/UpgradeButton";

const TopNavigationContainer = styled.div<{ isHidden: boolean }>`
    position: fixed;
    top: ${(props) => (props.isHidden ? `calc(-${Styles.topBarHeight} - 8px)` : 0)};
    transition: top 0.3s ease-out;
    z-index: ${Styles.zIndexTopNavigation};

    width: 100%;
    display: flex;
    padding: 8px;

    justify-content: space-between;
    align-items: center;
`;

const TopNavigationGroup = styled.div`
    display: flex;
    align-items: center;

    gap: 8px;
`;

const TopNavigationButtonContainer = styled.div`
    height: ${Styles.topBarHeight};
    background-color: ${(props) => props.theme.backgroundPrimary};
    border-radius: 5px;
    padding: 0 6px;

    display: flex;
    align-items: center;
    gap: 6px;
`;

const RoomButtonContainer = styled.div`
    display: flex;
    align-items: center;
`;

const ContainerDivider = styled(ButtonDivider)`
    height: 25px;
`;

interface TopNavigationProps {
    readonly toggleSidebar: () => void;
}
export default function TopNavigation(props: TopNavigationProps) {
    const { userData } = useUserContext();
    const { isFocusModeActive } = useAppearanceContext();

    let leftGroup: ReactNode[] = [];
    if (!isMobileOnly) {
        leftGroup.push(<AppModeDropdown />);
    }
    leftGroup.push(<UserMetricsButton />);
    if (userData == null || getUserSubscriptionTier(userData?.proUserInfo) === UserSubscriptionTier.FREE) {
        leftGroup.push(<UpgradeButton />);
    }

    return (
        <TopNavigationContainer isHidden={isFocusModeActive ?? false}>
            <TopNavigationGroup>
                <TopNavigationButtonContainer>
                    {leftGroup.reduce((acc, val) => [].concat(acc, <ContainerDivider />, val))}
                </TopNavigationButtonContainer>

                <HideOnMobileScreenSizes>
                    {!window.todesktop && (
                        <TopNavigationButtonContainer>
                            <DesktopAppButton />
                        </TopNavigationButtonContainer>
                    )}
                </HideOnMobileScreenSizes>
            </TopNavigationGroup>

            <TopNavigationGroup>
                <HideOnMobileScreenSizes>
                    <TopNavigationButtonContainer>
                        <RoomButtonContainer>
                            <RoomsButtons key={`overlay-buttons-rooms-buttons`} />

                            <GroupTimerButton />
                        </RoomButtonContainer>
                    </TopNavigationButtonContainer>
                </HideOnMobileScreenSizes>

                <TopNavigationButtonContainer>
                    <CannyChangelog />
                    <SupportChatButton />
                    <FullScreenButton />
                    <ContainerDivider />
                    <MainDropdownMenu />
                </TopNavigationButtonContainer>
            </TopNavigationGroup>
        </TopNavigationContainer>
    );
}
